
export const TYPE_WORKSPACE_FREE = 'free';
export const TYPE_WORKSPACE_PREMIUM = 'premium';
export const TYPE_WORKSPACE_STARTER = 'starter';
export const TYPE_WORKSPACE_SELF_SERVE = 'self_serve';
export const TYPE_WORKSPACE_MANAGED = 'managed';
export const TYPE_WORKSPACE_EXPIRED = 'premiumExpired';
export const PAID_WORKSPACE_TYPES = [
  TYPE_WORKSPACE_PREMIUM,
  TYPE_WORKSPACE_STARTER,
  TYPE_WORKSPACE_SELF_SERVE,
  TYPE_WORKSPACE_MANAGED,
  TYPE_WORKSPACE_EXPIRED,
];
export const WSTYPE_TO_DEFAULT_LICENSE_COUNTS = {
  [TYPE_WORKSPACE_FREE]: {
    users: 3,
    guests: 10,
  },
  [TYPE_WORKSPACE_STARTER]: {
    users: 3,
    guests: 10,
  },
  [TYPE_WORKSPACE_SELF_SERVE]: {
    users: 10,
    guests: 25,
  },
  [TYPE_WORKSPACE_MANAGED]: {
    users: 25,
    guests: 9999,
  },
};
